import { render, staticRenderFns } from "./outputBasicTabs.vue?vue&type=template&id=422a4dc0&scoped=true&"
import script from "./outputBasicTabs.vue?vue&type=script&lang=js&"
export * from "./outputBasicTabs.vue?vue&type=script&lang=js&"
import style0 from "./outputBasicTabs.vue?vue&type=style&index=0&id=422a4dc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422a4dc0",
  null
  
)

export default component.exports